import React from 'react'

import Table from 'components/Table/Table'
import Button from 'components/Forms/Button/Button'

import { copyToClipboard } from 'utils/clipboard'

import iconCopy from 'images/icons/copy.svg'

import { DEFAULT_CURRENCY } from 'constants/currencies'

import { MODALS } from '../../constants'

import PriceBlock from './components/PriceBlock/PriceBlock'

const PRICE_DIFF_WARNING = 50

const getColumns = ({ currency, currenciesSymbol, exchangeRates, methods }) => [
    {
        headerLabel: 'ID',
        getMarks: product => [
            {
                image: iconCopy,
                label: 'Copy to clipboard',
                onClick: () => copyToClipboard(product.id),
            },
        ],
        getTitle: product => product.id,
        getValue: product => product.id,
        width: '6%',
    },
    {
        headerLabel: 'Product Code',
        getMarks: product => [
            {
                image: iconCopy,
                label: 'Copy to clipboard',
                onClick: () => copyToClipboard(product.productCode),
            },
        ],
        getTitle: product => product.productCode,
        getValue: product => product.productCode,
        width: '10%',
    },
    {
        headerLabel: 'Product ID',
        getMarks: product => [
            {
                image: iconCopy,
                label: 'Copy to clipboard',
                onClick: () => copyToClipboard(product.productId),
            },
        ],
        getTitle: product => product.productId,
        getValue: product => product.productId,
        width: '10%',
    },
    {
        headerLabel: 'Group',
        getTitle: product => product.group,
        getValue: product => product.group,
        width: '10%',
    },
    {
        headerLabel: 'Name',
        getTitle: product => product.name,
        getValue: product => product.name,
        width: '14%',
    },
    {
        headerLabel: 'Weight',
        getTitle: product => product.weight,
        getValue: product => product.weight,
        width: '5%',
    },
    {
        headerLabel: `Billing Cycle`,
        getValue: product => {
            if (product.billingCycleValue === -1) return 'Lifetime'
            if (product.billingCycleValue === 1) return 'Monthly'
            if (product.billingCycleValue === 12) return 'Yearly'
        },
        width: '9%',
    },
    {
        headerLabel: `Price`,
        getValue: product => {
            const defaultCurrencyPrice = product.multiCurrencyPrice[DEFAULT_CURRENCY]
            if (!defaultCurrencyPrice) return null

            const price = product.multiCurrencyPrice[currency]

            const exchangeRate = exchangeRates[currency]
            let defaultPriceRate = null
            let defaultPriceDiffPercentage = null
            let isHighlightDefaultPriceRate = false
            if (currency !== DEFAULT_CURRENCY && exchangeRate) {
                defaultPriceRate = price / exchangeRate
                const diff = (defaultPriceRate / defaultCurrencyPrice) * 100 - 100
                defaultPriceDiffPercentage = `${diff > 0 ? '+' : '-'}${Math.abs(diff).toFixed(1)}`
                isHighlightDefaultPriceRate = diff < -PRICE_DIFF_WARNING || diff > PRICE_DIFF_WARNING
            }

            return (
                <PriceBlock
                    price={product.multiCurrencyPrice[currency]}
                    billingCycle={product.billingCycleValue}
                    currencySymbol={currenciesSymbol[currency]}
                    isHighlightDefaultPriceRate={isHighlightDefaultPriceRate}
                    defaultPriceDiffPercentage={defaultPriceDiffPercentage}
                    defaultPriceRate={defaultPriceRate}
                    isShowEditButton={currency !== DEFAULT_CURRENCY}
                    isShowAddButton={currency !== DEFAULT_CURRENCY}
                    isShowRemoveButton={currency !== DEFAULT_CURRENCY}
                    onEdit={() => methods.onOpenModal(MODALS.EDIT_PRICE, { product, currency })}
                    onAdd={() => methods.onOpenModal(MODALS.ADD_PRICE, { product, currency })}
                    onDelete={() => methods.onOpenModal(MODALS.DELETE_PRICE, { product, currency, isInflated: false })}
                />
            )
        },
        width: '13%',
    },
    {
        headerLabel: `Inflated Price`,
        getValue: product => {
            if (!product.multiCurrencyPrice[currency]) return null

            const price = product.inflatedPrice?.[currency] || null

            return (
                <PriceBlock
                    price={price}
                    billingCycle={product.billingCycleValue}
                    currencySymbol={currenciesSymbol[currency]}
                    isShowEditButton
                    isShowRemoveButton
                    isShowAddButton
                    isWarning={!!price && product.multiCurrencyPrice[currency] >= price}
                    onEdit={() => methods.onOpenModal(MODALS.EDIT_INFLATED_PRICE, { product, currency })}
                    onAdd={() => methods.onOpenModal(MODALS.ADD_INFLATED_PRICE, { product, currency })}
                    onDelete={() => methods.onOpenModal(MODALS.DELETE_PRICE, { product, currency, isInflated: true })}
                />
            )
        },
        width: '13%',
    },
    {
        getValue: product => (
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <Button
                    content="Features"
                    variant="primary"
                    isInverse={true}
                    onClick={() => methods.onOpenModal(MODALS.FEATURES, product)}
                />
            </div>
        ),
        width: '10%',
    },
]

const ProductsTable = ({ currenciesSymbol, currency, title, list, exchangeRates, methods, isLoading }) => (
    <Table
        columns={getColumns({ currency, currenciesSymbol, exchangeRates, methods })}
        isShowCounter={false}
        title={title}
        list={list}
        isLoading={isLoading}
    />
)

export default ProductsTable
